import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VendorContractorHeadcountService {
  private currentVendorName: string | null = null;

  constructor(private http: HttpClient) {}

  setVendorName(vendorName: string): void {
    this.currentVendorName = vendorName;
  }

  fetchContractorData(selectedMonth: string): Observable<any> {
    const [monthName, year] = selectedMonth.split(' ');
    const month = new Date(`${monthName} 1, ${year}`).getMonth() + 1;
    if (!this.currentVendorName) {
      throw new Error('Vendor name is required to fetch contractor data.');
    }
    const vendorName = decodeURIComponent(this.currentVendorName);
    const params = new HttpParams()
      .set('employerName', vendorName)
      .set('month', month.toString())
      .set('year', year.toString());
    return this.http.get<any>(
      `${environment.apiUrl}/vendor/contractors-count`,
      { params },
    );
  }
}
